import { useToasts } from '@/common/composables/useToast';
import axios from 'axios';

const apiMunzenCatalogos = axios.create({
  baseURL: import.meta.env.VITE_CATALOGOS_MUNZEN_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Initialize toast composable
const { errorToast } = useToasts();

// Response interceptor
apiMunzenCatalogos.interceptors.response.use(
  response => {
    // Check if Laravel returned an error in the response body
    if (response.data && response.data.success === false && response.data.dataError) {
      errorToast('Error del Servidor', response.data.dataError);
      return Promise.reject(new Error(response.data.dataError));
    }
    return response;
  },
  error => {
    let errorMessage = 'Ha ocurrido un error inesperado';

    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;

      // Handle Laravel error format
      if (data && data.success === false && data.dataError) {
        errorMessage = data.dataError;
      } else if (data && data.message) {
        errorMessage = data.message;
      } else {
        // Handle common HTTP status codes
        switch (status) {
          case 400:
            errorMessage = 'Solicitud incorrecta. Por favor, revise su entrada.';
            break;
          case 401:
            errorMessage = 'No autorizado. Por favor, inicie sesión de nuevo.';
            break;
          case 403:
            errorMessage = 'Acceso denegado. No tiene permiso.';
            break;
          case 404:
            errorMessage = 'Recurso no encontrado.';
            break;
          case 422:
            errorMessage = 'Error de validación. Por favor, revise su entrada.';
            break;
          case 500:
            errorMessage = 'Error interno del servidor. Por favor, intente de nuevo más tarde.';
            break;
          default:
            errorMessage = `Error del servidor: ${status}`;
        }
      }
    } else if (error.request) {
      // Network error
      errorMessage = 'Error de red. Por favor, compruebe su conexión.';
    } else {
      // Other error
      errorMessage = error.message || 'Ha ocurrido un error inesperado';
    }

    // Display error toast
    errorToast('Error de Comunicación', errorMessage);

    return Promise.reject(error);
  },
);

export default apiMunzenCatalogos;
